<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img11_4" src="images/img11_4.jpg"/></p>
<p class="caption">Men in New York searched the lists daily. 8US</p>
<p class="caption">Dubbed ‘America’s biggest lottery’. A blindfolded Secretary of State in Washington drew out a number, and every man in the 4,577 selective draft districts in the United States holding that particular number was the first man drawn to the colours in his district. As the numbers were drawn lists were posted throughout the country.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01n_AMERICAN_EXPEDITIONARY_FORCE.vue?60b6bb00